import { Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import { Controller, useFormContext } from 'react-hook-form';

interface FormInputProps extends TextAreaProps {
  name: string;
}

export const FormTextArea = ({ name, defaultValue, ...props }: FormInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => <Input.TextArea value={value} onChange={onChange} {...props} />}
    />
  );
};
